import React from "react";
import { ReactComponent as HERO_IMG } from "../assets/svg/heroImage.svg";

const Hero = () => {
  return (
    <div className="bg-green-200 flex flex-col md:flex-row md:justify-between text-center md:text-justify py-8 md:py-12 md:px-12 lg:py-36 lg:px-32 px-2 xl:px-48">
      <HERO_IMG className="h-64 w-64 lg:w-2/5 xl:w-1/2 self-center md:order-last" />
      <div className="max-w-6xl lg:w-3/5 xl:w-1/2">
        <h1 className="text-gray-900 text-2xl md:text-5xl lg:text-6xl font-bold">
          Hornet Vision
        </h1>
        <h1 className="py-4 text-xl text-gray-700">
          Let us know and we will put your events on our campus map! Bring your
          events to live and get recognize.
        </h1>
        <div className="flex justify-center md:justify-start">
          <h1 className="text-sac hover:underline font-black text-xl  sm:flex-none">
            Will be available for download soon...
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Hero;
